import { useQuery } from "@tanstack/react-query";
import { checklistQuestionsService } from "../services";
import type { GetAllQuestionsParams } from "../types";

export const useChecklistQuestionsList = (params?: GetAllQuestionsParams) =>
	useQuery({
		queryKey: ["checklistQuestions", params],
		queryFn: () => checklistQuestionsService.getAllQuestions(params),
	});

export const useChecklistQuestionById = (id: number) =>
	useQuery({
		queryKey: ["checklistQuestion", id],
		queryFn: () => checklistQuestionsService.getQuestionById(id),
		enabled: !!id,
	});
